<template>
  <panel-main-template>
    <template v-slot:page-title>
      Компании
      <hints
          :title="'Узнай как работать с данным разделом за несколько минут'"
          :type="'youtube'"
          :url="getYotubeLink('company')"
      ></hints>
    </template>
    <template v-slot:page-info>
      В данном разделе вы можете управлять вашими компаниями. Если вы частный специалист, то
      можете создать компанию на свое имя.
    </template>
    <template v-slot:page-content>
      <div class="my-data--items">
        <div class="item" v-for="(item, index) in companyData" :key="index">
          <company-card
              :id="+item.company.id"
              :active="+item.active"
              :img="item.image"
              :name="item.company.name"
              :city="item.company.city"
              :address="item.company.address"
              :number="item.company.number"
              :hideButtons="0"
              @active="activeCompany"
              @edit="editCompany"
              @delete="deleteCompany"
          ></company-card>
        </div>
      </div>
      <div v-if="checkPermission('create_filial')" class="my-data--add mrg-t-25">
        <div class="section-title">Добавить новую компанию</div>
        <div class="my-data--add-fields mrg-t-25">
          <div class="left shadow-card">
            <div class="input-block">
              <label for="new_name"
              >Название вашей компании <span class="req">*</span></label>
              <input
                  type="text"
                  @focus="formError.name = ''"
                  @blur="vName"
                  v-model="formData.name"
                  id="new_name"
              />
              <div class="hint">
                Название вашей компании. Если у вас нет компании, то можете ввести
                свое имя или фамилию. Это будут видеть те, кто записывается к вам
              </div>
              <div class="form-error">{{ formError.name }}</div>
            </div>
            <div class="input-block">
              <label for="new_city">Город <span class="req">*</span></label>
              <input
                  type="text"
                  @focus="formError.city = ''"
                  @blur="vCity"
                  v-model="formData.city"
                  id="new_city"
              />
              <div class="form-error">{{ formError.city }}</div>
            </div>
            <div class="input-block">
              <label for="lattitude">
                Широта (необязательное поле)
                
                <hints :type="'text'" :title="'Узнать координаты компании'">
                  <div slot="text">
                    <p>Рассмотрим получения координат на примере сервиса Яндекс.Карты</p>
                    <p>
                      Найдите место, координаты которого вам необходимо получить. Кликните правой кнопкой мыши. 
                      Откроется контекстное меню, где вам необходимо нажать на "Что здесь?"
                    </p>
                    <div class="text-center">
                      <img style="width:85%;" src="../../assets/img/map/instruction_1.png">
                    </div>
                    <p>Далее, слева откроется панель с координатами</p>
                    <div class="text-center">
                      <img style="width:85%;" src="../../assets/img/map/instruction_2.png">
                    </div>
                    <p>Просто вставьте данные координаты в поля. Первое число - это широта, второе - долгота.</p>
                    <p>
                      Если у компании есть координаты, клиент увидит иконку перехода к картам, рядом с адресом 
                      на странице записи онлайн.
                    </p>
                  </div>
                </hints>
              </label>
              <input
                type="text"
                @focus="formError.lattitude = ''"
                @blur="vLattitude"
                v-model="formData.lattitude"
                id="lattitude"
              />
              <div class="form-error">{{ formError.lattitude }}</div>
              <div class="hint">
                Параметр указывается для отображения вашей компании на карте.
                Нажмите на "?" для получения справочной информации
              </div>
            </div>
            <div class="input-block">
              <label for="longtitude">
                Долгота (необязательное поле)

                <hints :type="'text'" :title="'Узнать координаты компании'">
                  <div slot="text">
                    <p>Рассмотрим получения координат на примере сервиса Яндекс.Карты</p>
                    <p>
                      Найдите место, координаты которого вам необходимо получить. Кликните правой кнопкой мыши. 
                      Откроется контекстное меню, где вам необходимо нажать на "Что здесь?"
                    </p>
                    <div class="text-center">
                      <img style="width:85%;" src="../../assets/img/map/instruction_1.png">
                    </div>
                    <p>Далее, слева откроется панель с координатами</p>
                    <div class="text-center">
                      <img style="width:85%;" src="../../assets/img/map/instruction_2.png">
                    </div>
                    <p>Просто вставьте данные координаты в поля. Первое число - это широта, второе - долгота.</p>
                    <p>
                      Если у компании есть координаты, клиент увидит иконку перехода к картам, рядом с адресом 
                      на странице записи онлайн.
                    </p>
                  </div>
                </hints>
              </label>
              <input
                type="text"
                @focus="formError.longtitude = ''"
                @blur="vLongtitude"
                v-model="formData.longtitude"
                id="longtitude"
              />
              <div class="form-error">{{ formError.longtitude }}</div>
              <div class="hint">
                Параметр указывается для отображения вашей компании на карте.
                Нажмите на "?" для получения справочной информации
              </div>
            </div>
            <div class="my-data--company-card">
              <company-card
                  :id="0"
                  :active="0"
                  :img="image"
                  :name="formData.name"
                  :city="formData.city"
                  :address="formData.address"
                  :number="formData.number"
                  :hideButtons="1"
              ></company-card>
            </div>
            <div class="input-block">
              <label class="btn btn-sm btn-info" for="my-data-logo"
              >Изменить изображение...</label
              >
              <input id="my-data-logo" type="file" @change="changePhoto" />
            </div>
          </div>
          <div class="right shadow-card">
            <div class="input-block">
              <label for="new_address">Адрес <span class="req">*</span></label>
              <input
                  type="text"
                  @focus="formError.address = ''"
                  @blur="vAddress"
                  v-model="formData.address"
                  id="new_address"
              />
              <div class="form-error">{{ formError.address }}</div>
            </div>
            <div class="input-block mb-0">
              <label>Номер телефона <span class="req">*</span></label>
              <phone-number
                  v-model="formData.number"
                  :request-validate="requestValidateNumber"
                  @mask="setPhoneMask"
              ></phone-number>
            </div>

            <div class="input-block">
              <label for="company_status">
                Статус работы компании <span class="req">* </span>
                <hints :type="'text'" :title="'Что такое статус работы компании?'">
                  <div slot="text">
                    <p>Компания имеет 3 состояния:</p>
                    <p>
                      1. <b>Работает</b> - статус в котором клиентам доступна ваша компания по ссылке или 
                      виджету на сайте и они могут самостоятельно произвести запись
                    </p>
                    <p>
                      2. <b>Временно закрыта</b> - статус в котором клиенты могут попасть на страницу записи,
                      но не могут записаться и видят ваш текст с причиной закрытия, в котором можно написать
                      почему закрыто, до какого числа закрыто и т.д...<br>
                      При этом, если у вас несколько компаний, то на общей странице записи временно закрытая
                      компания будет отображаться так же с объявлением
                    </p>
                    <p>
                      3. <b>Полностью скрыть</b> - клиенты, обратившись по ссылке записи видят текст, что такой
                      компании не существует.
                      При этом, вы можете продолжать с ней работать в личном кабинете.
                    </p>
                  </div>
                </hints>
              </label>
              <select id="company_status" v-model="formData.company_status">
                <option value="0">Работает</option>
                <option value="1">Временно закрыта</option>
                <option value="2">Полностью скрыть от клиентов</option>
              </select>
            </div>

            <div v-show="+formData.company_status === 1" class="input-block">
              <label for="company_status">Описание причины закрытия</label>
              <textarea
                  rows="6"
                  v-model="formData.closed_description"
                  @focus="formError.closed_description = ''"
                  @blur="vClosedDescription"
              ></textarea>
              <div class="form-error">{{ formError.closed_description }}</div>
            </div>

            <div class="input-block">
              <label>Сообщение для клиента на e-mail <span class="req">*</span></label>
              <wysiwyg
                  type="text"
                  @focus="formError.ok_message = ''"
                  @blur="vOkMessage"
                  rows="6"
                  v-model="formData.ok_message"
                  placeholder="Введите текст..."
              ></wysiwyg>
              <div class="hint">
                То что вы укажете в этом поле будет приходить на почту вашим
                клиентам после записи. Вы можете, к примеру, поблагодарить за
                запись, написать подсказки, как вас найти и т.д...
              </div>
              <div class="form-error">{{ formError.ok_message }}</div>
            </div>
            <div class="input-block">
              <button @click="saveData" type="submit" class="btn btn-sm btn-success">
                Добавить
              </button>
            </div>
          </div>
        </div>
      </div>

      <croppie-component
        :fileModel="fileModel"
        @croppieSubmit="croppieSubmit"
      ></croppie-component>


      <croppie-component
          :fileModel="editCroppie.fileModel"
          @croppieSubmit="editCroppieSubmit"
      ></croppie-component>

      <right-modal :show="showEditModal" @closeRightModal="closeSraffModal">
        <div slot="body">
          <edit-company
            @updateCompany="updateCompany"
            @changePhoto="editCroppieChangePhoto"
            :data="editData"
            :croppieData="editCroppie"
          ></edit-company>
        </div>
      </right-modal>

      <popup
          :closeButton="deleteCompanyPopup.closeButton"
          :actionButton="deleteCompanyPopup.actionButton"
          :actionClass="deleteCompanyPopup.actionClass"
          :show="deleteCompanyPopup.show"
          @closePopup="closeDeleteCompanyPopup"
          @actionPopup="deleteSubmit"
      >
        <div slot="header">Подтвердить удаление?</div>
        <div slot="body">
          Внимание! Будут удалены все записи данной компании, сотрудники и сама компания
          без возможности восстановления. Продолжить?
        </div>
      </popup>

    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src
import PanelMainTemplate from "../../components/panel/MainTemplate";
import CroppieComponent from "../../components/CroppieComponent";
import RightModal from "../../components/RightModal";
import EditCompany from "../../components/panel/company/EditCompany";
import Validator from "../../components/libraries/Validator";
import Popup from "@/components/Popup";
import CompanyCard from "@/components/panel/my_data/CompanyCard";
import Hints from "@/components/Hints";
import youtubeMixin from "@/components/mixins/Youtube";
import PhoneNumber from "../../components/PhoneNumber";
import permissionMixin from '@/components/mixins/Permissions';
import userRepository from "../../repositories/user";

const validator = new Validator();

export default {
  name: "MyData",
  components: {
    PhoneNumber,
    Hints,
    CompanyCard,
    Popup,
    EditCompany,
    RightModal,
    CroppieComponent,
    PanelMainTemplate
  },
  mixins: [youtubeMixin, permissionMixin],
  data() {
    return {
      editCroppie: {
        image: null, // основная картинка для отображения. Null если должна быть пустая
        imageBase: null, // хэш из компонента CroppieComponent для передачи в REST
        fileModel: null, // записываем сюда event из инпута с type = file для передачи в CroppieComponent
        stImage: null
      },
      requestValidateNumber: 0,
      image: null, // основная картинка для отображения. Null если должна быть пустая
      imageBase: null, // хэш из компонента CroppieComponent для передачи в REST
      fileModel: null, // записываем сюда event из инпута с type = file для передачи в CroppieComponent
      st_logo: null,
      formData: {
        name: "",
        city: "",
        lattitude: "",
        longtitude: "",
        address: "",
        number: "",
        ok_message: "",
        company_status: 0,
        closed_description: ""
      },
      formError: {
        name: "",
        city: "",
        lattitude: "",
        longtitude: "",
        address: "",
        number: "",
        ok_message: "",
        company_status: "",
        closed_description: ""
      },
      deleteCompanyPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      deletedCompanyId: null,
      phoneMask: "",
      companyData: [],
      showEditModal: false,
      editData: {}
    };
  },
  metaInfo: {
    title: "Компании - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  computed: {
    validateData() {
      let errorCount = 0;
      this.vName().result === "error" ? errorCount++ : "";
      this.vCity().result === "error" ? errorCount++ : "";
      this.vAddress().result === "error" ? errorCount++ : "";
      this.vNumber().result === "error" ? errorCount++ : "";
      this.vOkMessage().result === "error" ? errorCount++ : "";
      this.vLattitude().result === "error" ? errorCount++ : "";
      this.vLongtitude().result === "error" ? errorCount++ : "";
      this.vClosedDescription().result === "error" ? errorCount++ : "";

      return errorCount;
    }
  },
  methods: {
    editCroppieSubmit(data){
      this.editCroppie.image = data;
      this.editCroppie.imageBase = data;
    },
    editCroppieChangePhoto(file){
      this.editCroppie.fileModel = file;
    },
    setPhoneMask(val){
      this.phoneMask = val;
    },
    vName() {
      let validate = validator.validate([
        {
          fieldName: "Название компании",
          value: this.formData.name,
          type: "required",
          length: 255
        }
      ]);
      validate.result == "error"
        ? (this.formError.name = validate.message)
        : (this.formError.name = "");
      return validate;
    },
    vCity() {
      let validate = validator.validate([
        {
          fieldName: "Город",
          value: this.formData.city,
          type: "required",
          length: 45
        }
      ]);
      validate.result == "error"
        ? (this.formError.city = validate.message)
        : (this.formError.city = "");
      return validate;
    },
    vLattitude(){
      let validate = validator.validate([
        {
          fieldName: "Широта",
          value: this.formData.lattitude,
          type: "integer"
        }
      ]);
      validate.result == "error"
        ? (this.formError.lattitude = validate.message)
        : (this.formError.lattitude = "");
      return validate;
    },
    vLongtitude(){
      let validate = validator.validate([
        {
          fieldName: "Долгота",
          value: this.formData.longtitude,
          type: "integer"
        }
      ]);
      validate.result == "error"
        ? (this.formError.longtitude = validate.message)
        : (this.formError.longtitude = "");
      return validate;
    },
    vAddress() {
      let validate = validator.validate([
        {
          fieldName: "Адрес",
          value: this.formData.address,
          type: "required",
          length: 255
        }
      ]);
      validate.result == "error"
        ? (this.formError.address = validate.message)
        : (this.formError.address = "");
      return validate;
    },
    vNumber() {
      this.requestValidateNumber++;
      let validate = validator.validate([
        {
          fieldName: "Номер",
          value: this.formData.number,
          type: "required",
          length: 20
        },
        {
          fieldName: "Номер",
          value: this.formData.number,
          type: "mask",
          mask: this.phoneMask
        }
      ]);
      validate.result == "error"
        ? (this.formError.number = validate.message)
        : (this.formError.number = "");
      return validate;
    },
    vClosedDescription() {
      let validate = validator.validate([
        {
          fieldName: "Описание причины закрытия",
          value: this.formData.closed_description,
          type: "string",
          length: 255
        }
      ]);
      validate.result == "error"
          ? (this.formError.closed_description = validate.message)
          : (this.formError.closed_description = "");
      return validate;
    },
    vOkMessage() {
      let validate = validator.validate([
        {
          fieldName: "Сообщение для клиента",
          value: this.formData.ok_message,
          type: "required",
          length: 1000
        }
      ]);
      validate.result == "error"
        ? (this.formError.ok_message = validate.message)
        : (this.formError.ok_message = "");
      return validate;
    },
    updateCompany() {
      this.getCompanyData();
      this.showEditModal = false;
    },
    closeSraffModal() {
      this.showEditModal = false;
    },
    editCompany(company) {
      this.showEditModal = true;
      for (let key in this.companyData) {
        if (+this.companyData[key].company.id === +company) {
          this.editData = this.companyData[key];
          this.editCroppie.imageBase = null;
          this.editCroppie.image = this.companyData[key].image;
        }
      }
    },
    changePhoto(file) {
      this.fileModel = file;
    },
    croppieSubmit(data) {
      this.image = data;
      this.imageBase = data;
    },
    saveData() {
      if (this.validateData) {
        return false;
      }
      this.$store.dispatch("startPreloader");

      userRepository.setCompanyData({
        name: this.formData.name,
        city: this.formData.city,
        lattitude: this.formData.lattitude,
        longtitude: this.formData.longtitude,
        address: this.formData.address,
        number: this.formData.number,
        ok_message: this.formData.ok_message,
        logo: this.imageBase,
        company_status: this.formData.company_status,
        closed_description: this.formData.closed_description
      }).then(resp => {
        let now = new Date();
        this.companyData = resp.data.data;
        if (resp.data.st_logo) {
          this.image = resp.data.st_logo + "?update=" + now.getTime();
        }
        this.resetForm();
        this.$store.dispatch("addNotification", {
          text: "Новая компания успешно добалена",
          time: 4,
          color: "success"
        });

        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    activeCompany(company) {
      this.$store.dispatch("startPreloader");

      userRepository.setCompanyActive({ company_id: company }).then(resp => {
        this.companyData = resp.data.data;
        this.resetForm();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    closeDeleteCompanyPopup(){
      this.deleteCompanyPopup.show = false;
    },
    deleteSubmit(){
      this.$store.dispatch("startPreloader");

      userRepository.deleteCompany({ company: this.deletedCompanyId }).then(resp => {
        if(resp.data.result === 'ok'){
          this.closeDeleteCompanyPopup();
          this.getCompanyData();
          this.$store.dispatch("addNotification", {
            text: 'Компания успешно удалена',
            time: 3,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    deleteCompany(company){
      this.deleteCompanyPopup.show = true;
      this.deletedCompanyId = company;
    },
    getCompanyData() {
      this.$store.dispatch("startPreloader");

      userRepository.getCompanyData().then(resp => {
        let now = new Date();
        this.companyData = this.formatGetData(resp.data.data);
        if (resp.data.st_logo) {
          this.st_logo = resp.data.st_logo + "?update=" + now.getTime();
          this.image = resp.data.st_logo + "?update=" + now.getTime();
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    formatGetData(data) {
      let now = new Date();
      for (let key in data) {
        data[key].image = data[key].image + "?update=" + now.getTime();
      }
      return data;
    },
    resetForm() {
      this.formData.name = null;
      this.formData.city = null;
      this.formData.address = null;
      this.formData.number = '';
      this.formData.ok_message = null;
      this.formData.company_status = 0;
      this.formData.closed_description = "";
      this.image = this.st_logo;
      this.imageBase = null;
    }
  },
  created() {
    this.getCompanyData();
  }
};
</script>

<style scoped lang="less">
.my-data--logo {
  text-align: center;

  & img {
    width: 200px;
  }
}

.my-data--items {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;

  .item {
    width: 320px;
    margin-right: 20px;
    margin-bottom: 10px;
    .img {
      img {
        width: 50px;
      }
    }
  }
}
.my-data--add-fields{
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-direction: row;

  .left{
    width: 49%;
  }
  .right{
    width: 49%;
  }
}
.my-data--company-card{
  width: 280px;
}
@media (max-width: 700px) {
  .my-data--items {
    justify-content: space-around;
    margin-top: 8px;

    // .item {
    //   width: 320px;
    //   margin-right: 20px;
    //   margin-bottom: 10px;
    //   .img {
    //     img {
    //       width: 50px;
    //     }
    //   }
    // }
  }
  .my-data--add-fields{
    flex-wrap: wrap;

    .left{
      width: 100%;
    }
    .right{
      width: 100%;
    }
  }
}

@media (max-width: 690px) {
  .my-data--items {

    .item {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
</style>
